import { batch } from "@preact/signals-react";

import { commonFiltersValue } from "@signals";
import { stockAssDetailsNotListedFilters } from "../../@signals";


export default function useStockAssortmentDetailsShowNotListed(retailer, seller=null) {

	const handleClickShowNotListed = () => batch(() => {
		stockAssDetailsNotListedFilters.value = {
            ...commonFiltersValue.peek(),
			retailer: [retailer],
			sellers: !!seller ? [seller] : []
        }
	})
   
	return {
		handleClickShowNotListed
	}
}